import { useEffect, useRef } from 'react'

import MouseOverCard from './MouseOverCard'

import { Arrow, Connector, Dot, MouseOverContainer } from './MouseOver.styles'

import { MouseOverProps } from './MouseOver.types'

import { useMouseOver } from './useMouseOver'

const DEFAULT_FOCUS_TIME = 3000

const MouseOver = ({
  elementRef,
  content,
  focusTime = DEFAULT_FOCUS_TIME
}: MouseOverProps) => {
  const tooltipRef = useRef<HTMLDivElement>(null)

  const { position, isVisible, openCard, closeCard } = useMouseOver({
    elementRef,
    tooltipRef
  })

  useEffect(() => {
    const element = elementRef?.current

    const onFocus = () => {
      const timeout = setTimeout(openCard, focusTime)
      element?.addEventListener('blur', () => clearTimeout(timeout))
    }

    element?.addEventListener('focus', onFocus)

    return () => {
      element?.removeEventListener('focus', onFocus)
    }
  }, [elementRef, focusTime, openCard])

  if (!isVisible) {
    return null
  }

  return (
    <MouseOverContainer
      ref={tooltipRef}
      style={{
        top: position.top,
        left: position.left
      }}
    >
      <Connector
        style={{ top: position.connectorsTop, left: position.connectorsLeft }}
      >
        <Arrow />
        <Dot alignment={position.alignment} />
      </Connector>
      <MouseOverCard {...content} onClose={closeCard} />
    </MouseOverContainer>
  )
}

export default MouseOver
